import { Modal, Paper } from "@mantine/core";
import React from "react";
import AdminPage from "../AdminPage";

const ModalWrapper = ({
  opened,
  setOpened,
  form,
  InternalComponent,
  title,
  size = "xl",
  setEditData,
  setEditModalState,
  addEdit,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {
        if (addEdit) {
          setEditData({});
          form.reset();
          setEditModalState(false);
        }
        setOpened(false);
      }}
      styles={{
        modal: {
          backgroundColor: "#F8F8F8",
        },
      }}
      size={size}
    >
      <div
        style={{
          marginTop: "-40px",
        }}
      >
        <AdminPage title={title}>
          {
            <Paper px="xl" py="sm">
              {InternalComponent}
            </Paper>
          }
        </AdminPage>
      </div>
    </Modal>
  );
};

export default ModalWrapper;
